import React, { useEffect, useState } from "react";
import { GET_WITH_TOKEN } from "../../Backend/Bakend";
import { showToast } from "../Constent/Toast";

const ItineraryRequests = () => {
  const [rows, setRows]         = useState([]);
  const [page, setPage]         = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal]       = useState(0);
  const [search, setSearch]     = useState("");
  const [loading, setLoading]   = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    load(1, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = (p, q) => {
    setLoading(true);
    const url = `/api/admin/itinerary-requests?page=${p}&search=${encodeURIComponent(q || "")}`;
    GET_WITH_TOKEN(url, "",
      (res) => {
        setLoading(false);
        const data = res?.data ?? res;
        setRows(Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []));
        setLastPage(Number(data?.last_page) || 1);
        setPage(Number(data?.current_page) || 1);
        setTotal(Number(data?.total) || 0);
      },
      (e) => { setLoading(false); showToast(e?.message || "Failed to load requests"); },
      (e) => { setLoading(false); showToast(e || "Network error"); }
    );
  };

  const onSearch = () => load(1, search);
  const onReset  = () => { setSearch(""); load(1, ""); };

  const fmtDate = (s) => (s ? new Date(s).toLocaleDateString() : "—");

  return (
    <div className="container mt-3" style={{ paddingBottom: 60 }}>
      <div className="card">
        <div className="card-header">
          <p style={{ fontSize: 25, margin: 0 }}>
            Itinerary Requests
            <span style={{ fontSize: 14, color: "#6c757d", marginLeft: 12 }}>({total} total)</span>
          </p>
          <div className="text-muted small mt-1">
            People who submitted the "Send Me My Itinerary" form on the public itinerary page.
          </div>

          <div className="d-flex mt-3" style={{ gap: 8 }}>
            <input
              className="form-control"
              style={{ maxWidth: 320 }}
              placeholder="Search by name, email, phone, or location…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && onSearch()}
            />
            <button onClick={onSearch}
                    style={{ background: "#008c93", color: "#fff", border: "none",
                             padding: "8px 18px", borderRadius: 6, cursor: "pointer" }}>
              Search
            </button>
            <button onClick={onReset}
                    style={{ background: "transparent", color: "#000", padding: "8px 16px",
                             borderRadius: 6, border: "1px solid gray", cursor: "pointer" }}>
              Reset
            </button>
          </div>
        </div>

        <div className="card-body" style={{ minHeight: 400 }}>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" />
              <p className="mt-2 small text-muted">Loading…</p>
            </div>
          ) : rows.length === 0 ? (
            <div className="text-muted text-center py-5">No requests yet.</div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-striped table-hover" style={{ fontSize: 14 }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Location</th>
                    <th>Travel date</th>
                    <th>Duration</th>
                    <th>Submitted</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={r.id}>
                      <td>{(page - 1) * 15 + i + 1}</td>
                      <td>{r.name || "—"}</td>
                      <td>{r.email || "—"}</td>
                      <td>{r.phone || "—"}</td>
                      <td>{r.location || "—"}</td>
                      <td>{fmtDate(r.travel_date)}</td>
                      <td>{r.duration || "—"}</td>
                      <td>{fmtDate(r.created_at)}</td>
                      <td>
                        <button className="btn btn-sm btn-outline-secondary"
                                style={{ padding: "2px 12px" }}
                                onClick={() => setSelected(r)}>
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {lastPage > 1 && (
            <div className="d-flex justify-content-center align-items-center mt-3" style={{ gap: 10 }}>
              <button className="btn btn-sm btn-outline-secondary"
                      disabled={page <= 1}
                      onClick={() => load(page - 1, search)}>← Prev</button>
              <span className="small text-muted">Page {page} of {lastPage}</span>
              <button className="btn btn-sm btn-outline-secondary"
                      disabled={page >= lastPage}
                      onClick={() => load(page + 1, search)}>Next →</button>
            </div>
          )}
        </div>
      </div>

      {selected && (
        <div
          onClick={() => setSelected(null)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 1050,
                   display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
        >
          <div onClick={(e) => e.stopPropagation()}
               style={{ background: "#fff", borderRadius: 10, maxWidth: 560, width: "100%",
                        padding: 24, boxShadow: "0 8px 30px rgba(0,0,0,.3)" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 style={{ margin: 0, color: "#008c93" }}>Request Details</h5>
              <button onClick={() => setSelected(null)}
                      style={{ background: "none", border: "none", fontSize: 22, lineHeight: 1, cursor: "pointer" }}>
                ×
              </button>
            </div>
            <Row k="Name"           v={selected.name} />
            <Row k="Email"          v={selected.email} />
            <Row k="Phone"          v={selected.phone} />
            <Row k="Location"       v={selected.location} />
            <Row k="Travel date"    v={fmtDate(selected.travel_date)} />
            <Row k="Duration"       v={selected.duration} />
            <Row k="Food preference" v={selected.food_preference} />
            <Row k="Stay category"  v={selected.stay_category} />
            <Row k="Group type"     v={selected.group_type} />
            <Row k="Submitted"      v={selected.created_at ? new Date(selected.created_at).toLocaleString() : "—"} />
          </div>
        </div>
      )}
    </div>
  );
};

const Row = ({ k, v }) => (
  <div style={{ display: "flex", padding: "6px 0", borderBottom: "1px solid #f1f3f5" }}>
    <div style={{ width: 150, color: "#6c757d", fontSize: 13 }}>{k}</div>
    <div style={{ flex: 1, fontSize: 14 }}>{v || "—"}</div>
  </div>
);

export default ItineraryRequests;
